<template>
<div class="modal-mask">
    <div class="modal-wrapper">
        <div  class="modal_size md_size">
            <a href="javascript:" class="ui_close" type="button" @click="btnClose"><span class="sr_only">popup close</span></a>
            <dl class="modal_content">
                <dt class="ellipsis">
                    <i>{{ $t('FIELD.GLOBAL.ETC.077') }}</i>
                </dt>
                <dd>
                    <dl class="srcModel_wrap">
                        <dt class="tree_box">
                            <!-- tree -->
                            <article class="tree_wrap">
                                <!-- <p class="tree_subtitle">Category</p> -->
                                <ul class="tree_list">
                                    <li v-for="(menu1, idx) in getRefineMenus" :key="'tree' + menu1.menuId">
                                        <a  href="javascript:"
                                            class="ico_tree"
                                            v-if="menu1.subMenu.length > 0"
                                            @click="treeClick($event, menu1.menuId)"
                                        >
                                            <span class="sr_only"></span>
                                        </a>
                                        <span @click="menuClick($event, menu1, menu1.subMenu)">
                                            {{ menu1.menuNm + (menu1.pcOnlyYn === 'Y' ? ' (PC Only)' : '') }}
                                        </span>
                                        <ul class="tree_sub_list" v-if="menu1.subMenu">
                                            <li v-for="menu2 in menu1.subMenu" :key="'tree' + menu2.menuId">
                                                <a  href="javascript:"
                                                    class="ico_tree"
                                                    v-if="menu2.subMenu.length > 0"
                                                    @click="treeClick($event, menu2.menuId)"
                                                >
                                                    <span class="sr_only"></span>
                                                </a>
                                                <span @click="menuClick($event, menu2, menu2.subMenu)">
                                                    {{ menu2.menuNm + (menu1.pcOnlyYn === 'Y' || menu2.pcOnlyYn === 'Y' ? ' (PC Only)' : '') }}
                                                </span>
                                                <ul class="tree_sub_list" v-if="menu2.subMenu">
                                                    <li v-for="menu3 in menu2.subMenu" :key="'tree' + menu3.menuId">
                                                        <a  href="javascript:"
                                                            class="ico_tree"
                                                            v-if="menu3.subMenu.length > 0"
                                                            @click="treeClick($event, menu3.menuId)"
                                                        >
                                                            <span class="sr_only"></span>
                                                        </a>
                                                        <span @click="menuClick($event, menu3, menu3.subMenu)">
                                                            {{ menu3.menuNm + (menu1.pcOnlyYn === 'Y' || menu2.pcOnlyYn === 'Y' || menu3.pcOnlyYn === 'Y' ? ' (PC Only)' : '') }}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </article>
                        </dt>
                        <dd class="btn">
                            <span>
                                <a href="javascript:" class="ico_arrow_next box" :title="$t('BUTTON.GLOBAL.ADD')" @click="btnAdd"></a>
                                <a  v-if="selMyMenuList.length > 0"
                                    href="javascript:"
                                    class="ico_arrow_prev box"
                                    :title="$t('BUTTON.GLOBAL.REMOVE')"
                                    @click="btnRemove"
                                ></a>
                            </span>
                        </dd>
                        <dd class="select_menu">
                            <div class="txt">Selected my Menus</div>
                            <!-- 200608수정 S -->
                            <ul v-if="selMyMenuList.length > 0" class="select_list">
                                <li v-for="selMenu in selMyMenuList"
                                    :class="selMenu.MENU_ID === selMyMenuId ? 'active' : ''"
                                    :data-id="selMenu.MENU_ID"
                                    @click="clickSelMyMenu(selMenu.MENU_ID)"
                                >
                                    {{ selMenu.MENU_NM }}
                                </li>
                            </ul>
                            <ul v-else class="select_list">
                                {{ $t('MESSAGE.GLOBAL.NO.DATA') }}
                            </ul>
                            <!-- 200608수정 E -->
                        </dd>
                    </dl>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="btn_modal_wrap topLine">
                        <div class="btn_right">
                            <a href="javascript:" class="btn_white" @click="btnClose">{{ $t('BUTTON.GLOBAL.CANCEL') }}</a>
                            <a href="javascript:" class="btn_blue" @click="btnApply">{{ $t('BUTTON.GLOBAL.APPLY') }}</a>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import Vue                      from 'vue';
import { mapGetters }           from 'vuex';
import _                        from 'lodash';
import $                        from 'jquery';
import axios                    from 'axios';
import qs                       from 'query-string';
import store                    from '@/vuex/store';
import { SDLUtil, MenuUtil }    from '@/utils';
import { EventBus }             from '@/utils/EventBus';

const fetchSetup = loginSystem => SDLUtil.postForm(
    '/basis/common/listGetMyMenuConfig.skp', { systemId: loginSystem }
);

export default {
    name: 'MyMenuConfigPopup',
    props: {
        rtnFunc: { type: Function }
    },
    data() {
        return {
            isMenuLoading: true,
            isChanged: false,

            selectedMenuObj: {},

            selMyMenuId: '',
            selMyMenuList: [],
        }
    },
    computed: {
        ...mapGetters({
            menus: 'getMenus',
            userCorpCd: 'getCorpCd',
            loginSystem: 'getLoginSystem',
            loginNo: 'getLoginNo',
        }),
        getRefineMenus() {
            if(this.menus) {
                let sortedMenus = _.sortBy(this.menus.filter(menu => menu.menuLevel == 1 && menu.subMenu.length > 0), ['sort3']);
                    sortedMenus = _.dropRightWhile(sortedMenus, [ 'menuId', 'TOP_1000000003' ]); // My Menus 제거
                    const ADMIN_MENU = MenuUtil.getAdminMenu;
                    for(let i = 0; i < ADMIN_MENU.length; i++) {
                        let adminMenu = ADMIN_MENU[i];
                        sortedMenus = _.dropRightWhile(sortedMenus, [ 'menuId', adminMenu ]); // Admin 제거
                    }

                return sortedMenus;

            } else {
                return [];
            }
        }
    },
    methods: {
        async initLoad() {
            SDLUtil.showLoadingBar(true);
            await fetchSetup(this.loginSystem).then( data => {
                let rowData = data.myMenuList.rowData;
                if( rowData.length > 0 ){
                    this.selMyMenuList = rowData;
                };

                SDLUtil.showLoadingBar(false);
            })
            .catch( err => {
                SDLUtil.showLoadingBar(false);
                SDLUtil.errorAlert(err);
            });
        },
        // 메뉴 클릭 이벤트
        treeClick(e) {
            if (
                $(e.target)
                    .closest('li')
                    .hasClass('active') == true
            ) {
                $(e.target)
                    .closest('li')
                    .removeClass('active');
            } else {
                $(e.target)
                    .closest('li')
                    .addClass('active');
            }
        },
        menuClick(e, menu, subMenu) {
            $('span.active').removeClass('active');
            if( $(e.target).closest('span').hasClass('active') === true ){
                $(e.target).closest('span').removeClass('active');
            } else {
                $(e.target).closest('span').addClass('active');
            };

            if(!SDLUtil.isNull(menu.connUrl) && this.selectedMenuObj.menuId !== menu.menuId) {
                this.selectedMenuObj = menu;
            }
        },
        btnAdd() {
            let that = this;
            let chkIdx = _.findIndex(this.selMyMenuList, function(m){ return m.MENU_ID === that.selectedMenuObj.menuId; });
            if(this.selMyMenuList.length < 3) {
                this.isChanged = true;
                if(!SDLUtil.isNull(this.selectedMenuObj.connUrl) && chkIdx === -1) {
                    let breads = this.searchBreads(this.selectedMenuObj.menuId);
                    let menuParams = {
                        WORK_KEY_1: '', WORK_KEY_2: '', WORK_KEY_3: '',
                        MENU_ID: this.selectedMenuObj.menuId,
                        MENU_NM: this.selectedMenuObj.menuNm
                    };

                    for(let i = 0; i < breads.length; i++){
                        menuParams['WORK_KEY_' + (i + 1)] = breads[i].menuId;
                    };

                    this.selMyMenuList.push(menuParams);
                };

            } else {
                return SDLUtil.alert('MESSAGE.DASHBOARD.ONLY.THREE.ITEMS');
            };
        },
        btnRemove() {
            let that = this;
            let chkIdx = _.findIndex(this.selMyMenuList, function(m){ return m.MENU_ID === that.selMyMenuId; });
            this.selMyMenuList.splice(chkIdx, 1);
            this.selMyMenuId = '', this.isChanged = true;
        },
        clickSelMyMenu(selMenuId) {
            if(this.selMyMenuId !== selMenuId) this.selMyMenuId = selMenuId;
        },
        searchBreads(selMenuId) {
            let breads = [],
                scanMenu = MenuUtil.menuScan(selMenuId, this.menus);

            if(scanMenu) {
                scanMenu.forEach((menu) => { if(menu.currMenu){ this.selMenuNm = menu.menuNm; breads.push(menu); } });
                for(let i = 0; i < breads[0].depth; i++){
                    let menuPid = breads[i].menuPid;
                    scanMenu.forEach((menu) => { if(menuPid === menu.menuId) breads.push(menu); });
                }

                return _.sortBy(breads, ['depth']);
            };
        },
        btnClose() {
            if(this.isChanged) {
                SDLUtil.confirm({
                    title: 'TITLE.WARNING.TITLE',
                    msg: 'MESSAGE.POPUP.CHANGE.CLOSE',
                    okLabel: 'BUTTON.GLOBAL.OK',
                    onOkEvt: () => { this.$emit('close') },
                });

            } else {
                this.$emit('close');
            }
        },
        btnApply() {
            console.log(this.selMyMenuList);
            //SDLUtil.showLoadingBar(true);
            let params = {
                systemId: this.loginSystem,
            };

            for(let i = 0; i < this.selMyMenuList.length; i++) {
                let myMenu = this.selMyMenuList[i];
                let menuParam = {};
                    menuParam['MENU_' + (i + 1) + '_WORK_KEY_1'] = myMenu['WORK_KEY_1'] || '';
                    menuParam['MENU_' + (i + 1) + '_WORK_KEY_2'] = myMenu['WORK_KEY_2'] || '';
                    menuParam['MENU_' + (i + 1) + '_WORK_KEY_3'] = myMenu['WORK_KEY_3'] || '';

                Object.assign(params, menuParam);
            };

            return SDLUtil.postForm('/basis/common/setMyMenuConfig.skp', params).then(data => {
                    this.toastPopup(SDLUtil.getMsgProp('MESSAGE.SUCCESS.SAVED'));
                    SDLUtil.showLoadingBar(false);

                    this.rtnFunc();
                    this.$emit('close');
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    SDLUtil.errorAlert(err);
                });
        },
        toastPopup(msg) {
            Vue.toasted.show( msg, { theme: "toasted-primary", position: "top-center", duration : 3000 } );
        },
    },
    created() {
        this.initLoad();
    }
};
</script>
<style scoped>
.tree_wrap .tree_list .tree_sub_list li span.active {font-weight:bold;}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/common/MyMenuConfigPopup.vue